import React, {FC, Fragment} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {TriggerWithConditions} from '../ruleTriggerHelpers';
import {RuleTriggersTypesEnum} from '../ruleTriggerModel';
import {EditorStateActions} from './hooks/useEditorState';
import {OrLabel} from './ruleEditorCommons';
import {RuleTriggerCard} from './ruleTriggerCard';

/*
 * Types.
 */

interface OrBlockProps {
  selectedTriggers: ReadonlyArray<TriggerWithConditions>;
  notDisplayingErrorCards?: ReadonlyArray<string>;

  onUpdateTrigger: EditorStateActions['onUpdateTrigger'];
  onRemoveTrigger?: HandlerOf<RuleTriggersTypesEnum>;
  onValidation: EditorStateActions['onValidation'];
}

/*
 * Component.
 */

export const RuleTriggerOrBlock: FC<OrBlockProps> = (props) => {
  const {selectedTriggers, notDisplayingErrorCards, onUpdateTrigger, onRemoveTrigger, onValidation} = props;

  return (
    <div>
      {selectedTriggers.map((triggerWithConditions, i) => (
        <Fragment key={triggerWithConditions.trigger}>
          <RuleTriggerCard
            triggerWithConditions={triggerWithConditions}
            shouldHideError={Boolean(notDisplayingErrorCards?.includes(triggerWithConditions.trigger))}
            onUpdateTrigger={onUpdateTrigger}
            onRemoveTrigger={onRemoveTrigger}
            onValidation={onValidation}
          />
          {maybeRenderOrLabel(i, selectedTriggers)}
        </Fragment>
      ))}
    </div>
  );
};

/*
 * Helpers.
 */

function maybeRenderOrLabel(i: number, triggers: ReadonlyArray<TriggerWithConditions>) {
  const shouldDisplayOr = i < triggers.length - 1;

  if (!shouldDisplayOr) {
    return null;
  }

  return <OrLabel />;
}
